import * as types from './mutation-types'

export const getSectionsInfos = ({ commit },page_name) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/section/collection?type='+page_name).then((response) => {
            resolve(response)
            console.log("sectionsOfHome",response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getPagesInfos = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/section/type/options').then((response) => {
            commit(types.LOAD_PAGES, response.data.data)
            resolve(response)
            console.log("pagesOfHome",response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createMedia = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('section/update', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getSocialMediaList = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/socialMedia/collection').then((response) => {
            commit(types.LOAD_SOCIAL_MEDIA, response.data.data)
            resolve(response)
            console.log("social",response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addSocialMedia = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/socialMedia', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteSocialMedia = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/socialMedia/${id}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const findMediaById = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`product/${id}/details`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteMedia = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`/section/image/${id}/delete`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateMediaSaleElements = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/productSaleElements/update`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const loadAllMedias = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/products/collection').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteMediaLot = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`productSaleElement/lot/${id}/delete`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



